<template>
  <div>
    <div class="content w-1200">
      <div class="top-box">
        <el-form label-position="left" :model="form" label-width="80px">
          <el-row>
            <el-col :span="6" :offset="1">
              <el-form-item label="cas">
                <el-input v-model="form.cas_no" placeholder="请输入CAS号"/>
              </el-form-item>
            </el-col>
            <el-col :span="6" :offset="1">
              <el-form-item label="标题">
                <el-input v-model="form.title" placeholder="请输入标题"/>
              </el-form-item>
            </el-col>
            <el-col :span="6" :offset="1">
              <el-form-item label="技术类型">
                <el-select
                    v-model="form.tech_type"
                    placeholder="请选择技术类型"
                >
                  <el-option label="专利" value="1"></el-option>
                  <el-option label="非专利" value="2"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="margin-top: 20px">
            <el-col :span="6" :offset="1">
              <el-form-item label="发布时间">
                <el-date-picker
                    v-model="form.created_at"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd"
                />
              </el-form-item>
            </el-col>
            <el-col :offset="9" :span="5" class="flex-end">
              <gradient-button @hit="handleSearch" background="#0C60E6"
              >搜索
              </gradient-button
              >
              <gradient-button
                  @hit="handleReset"
                  color="#5F616C"
                  border="1px solid #5F616C"
                  background="transparent"
              >刷新
              </gradient-button
              >
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="content-box">
        <div class="content-box-left">技术供需</div>
        <gradient-button background="#0C60E6" @hit="handleRelease"
        >新增
        </gradient-button
        >
      </div>
      <div class="fotter-box">
        <div class="teble-box">
          <el-table
              v-loading="loading"
              :data="tableData"
              style="width: 100%"
              :header-cell-style="{
              backgroundColor: '#F6F6F8',
              color: '#00112B',
            }"
          >
            <el-table-column prop="id" width="50" label="编号"/>
            <el-table-column prop="type" label="供需类型">
              <template slot-scope="scope">
                <span v-if="scope.row.type === 1">买技术(需求)</span>
                <span v-if="scope.row.type === 2">卖技术(供给)</span>
              </template>
            </el-table-column>
            <el-table-column prop="title" label="标题"  width="200"/>
            <el-table-column prop="cas_no" label="cas"/>
            <el-table-column prop="tech_type" label="技术类型">
              <template slot-scope="scope">
                <span v-if="scope.row.tech_type == 1">专利</span>
                <span v-if="scope.row.tech_type == 2">非专利</span>
              </template>
            </el-table-column>
            <el-table-column prop="created_at" label="发布时间">
              <template slot-scope="scope" v-if="scope.row.created_at">
                {{ scope.row.created_at.split(" ")[0] }}
              </template>
            </el-table-column>
            <el-table-column prop="upto_at" label="截止时间"/>
            <el-table-column prop="tech_status" label="状态">
              <template slot-scope="scope">
                <el-tag v-if="scope.row.tech_status === 1" type="success"
                >发布
                </el-tag
                >
                <el-tag v-if="scope.row.tech_status === 2" type="warning"
                >已成功转让
                </el-tag
                >
                <el-tag v-if="scope.row.tech_status === 3">找到合适供需</el-tag>
                <el-tag v-if="scope.row.tech_status === 4" type="danger"
                >已结束
                </el-tag
                >
              </template>
            </el-table-column>

            <el-table-column prop="area" label="地区"  width="200">
              <template slot-scope="scope" v-if="scope.row.address">
                {{
                  scope.row.address.province +
                  scope.row.address.city +
                  scope.row.address.area
                }}
              </template>
            </el-table-column>
            <el-table-column
                prop="operation"
                label="操作"
                width="160"
                fixed="right"
            >
              <template slot-scope="scope">
                <el-button
                    type="text"
                    size="small"
                    @click="handleDetail(scope.row)"
                >查看
                </el-button
                >
                <el-button
                    v-if="scope.row.tech_status==1"
                    type="text"
                    size="small"
                    @click="handleRelease(scope.row)"
                >编辑
                </el-button
                >
                <el-button
                    type="text"
                    @click="handleEnd(scope.row)"
                    v-if="scope.row.tech_status == 1"
                    size="small"
                >结束
                </el-button
                >
                <el-button
                    type="text"
                    @click="handleDelete(scope.row)"
                    size="small"
                >删除
                </el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="pagination-box">
          <el-pagination
              class="float-right"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="page"
              :page-sizes="[10, 20, 30, 40]"
              :page-size="pageSize"
              background
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <!-- 新增技术供需弹窗 -->
    <el-dialog
        :close-on-press-escape="false"
        :close-on-click-modal="false"
        :modal-append-to-body="false"
        :title="titleDing+'供给'"
        :visible.sync="dialogVisible"
    >
      <div class="form-box">
        <el-form
            ref="addFormRules"
            :model="addForm"
            :rules="addFormRules"
            label-width="100px"
            label-position="right"
        >
          <el-row>
            <el-form-item label="供需类型" prop="type">
              <el-radio-group v-model="addForm.type">
                <el-radio :label="1">买技术(需求)</el-radio>
                <el-radio :label="2">卖技术(供给)</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="标题" prop="title">
              <el-input
                  v-model="addForm.title"
                  placeholder="请输入标题"
              ></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="CAS号" prop="cas_no">
                <el-input
                    v-model="addForm.cas_no"
                    placeholder="请输入CAS号"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="技术类型" prop="tech_type">
                <el-radio-group v-model="addForm.tech_type">
                  <el-radio
                      v-for="item in technologyList"
                      :key="item.id"
                      :label="item.value"
                  >{{ item.label }}
                  </el-radio
                  >
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-form-item label="合作方式" prop="co_type">
              <el-radio-group v-model="addForm.co_type">
                <el-radio
                    v-for="item in coTypeList"
                    :key="item.id"
                    :label="item.label"
                >{{ item.label }}
                </el-radio
                >
              </el-radio-group>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="技术成熟度" prop="tech_maturity">
              <el-radio-group v-model="addForm.tech_maturity">
                <el-radio
                    v-for="item in techMaturityList"
                    :key="item.id"
                    :label="item.label"
                >{{ item.label }}
                </el-radio
                >
              </el-radio-group>
            </el-form-item>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="价格" prop="">
                <el-input
                    v-model="addForm.price"
                    placeholder="请输入,不填默认为面议"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="截止日期" prop="upto_at">
                <el-date-picker
                    v-model="addForm.upto_at"
                    type="date"
                    class="custom-input"
                    placeholder="请选择"
                    value-format="yyyy-MM-dd"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="手机号" prop="phone">
                <el-input
                    v-model="addForm.phone"
                    placeholder="请输入手机号"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="所在地区" prop="address">
                <el-cascader
                    v-model="addForm.address"
                    :options="areaOptions"
                ></el-cascader>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-form-item label="技术详情" prop="detile">
              <el-input
                  v-model="addForm.detile"
                  type="textarea"
                  :rows="5"
                  placeholder="请输入技术描述"
              ></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-col :span="2" :offset="14">
              <gradient-button
                  @hit="handleConfirm"
                  width="120px"
                  height="40px"
                  background="#0C60E6"
              >确认
              </gradient-button
              >
            </el-col>
            <el-col :span="2" :offset="4">
              <gradient-button
                  @hit="handleCancel"
                  width="120px"
                  height="40px"
                  color="#5F616C"
                  background="transparent"
                  border="1px solid #5F616C"
              >取消
              </gradient-button
              >
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-dialog>
    <!-- 技术供需详情弹窗 -->
    <el-dialog
        :close-on-press-escape="false"
        :close-on-click-modal="false"
        :modal-append-to-body="false"
        title="技术供需详情"
        :visible.sync="detailVisible"
        :before-close="detailClose"
        width="50%"
    >
      <div class="detail-box" v-loading="popuploading">
        <table class="detail-table" v-if="detail" border="1">
          <tr>
            <td>供需类型</td>
            <td>{{ detail.type == 1 ? "买技术(需求)" : "卖技术(供给)" }}</td>
            <td>CAS号</td>
            <td>{{ detail.cas_no }}</td>
          </tr>
          <tr>
            <td>标题</td>
            <td colspan="3">{{ detail.title }}</td>
          </tr>
          <tr>
            <td>技术类型</td>
            <td>{{ detail.tech_type == 1 ? "专利" : "非专利" }}</td>
            <td>合作方式</td>
            <td>{{ detail.co_type }}</td>
          </tr>
          <tr>

            <td>技术成熟度</td>
            <td>{{ detail.tech_maturity }}</td>
          </tr>
          <tr>
            <td>截止日期</td>
            <td>{{ detail.upto_at }}</td>
            <td>发布时间</td>
            <td v-if="detail.created_at">
              {{ detail.created_at.split(" ")[0] }}
            </td>
          </tr>
          <tr>
            <td>状态</td>
            <td>
              <el-tag v-if="detail.tech_status == 1" type="success"
              >发布
              </el-tag
              >
              <el-tag v-if="detail.tech_status == 2" type="warning"
              >已成功转让
              </el-tag
              >
              <el-tag v-if="detail.tech_status == 3">找到合适供需</el-tag>
              <el-tag v-if="detail.tech_status == 4" type="danger"
              >已结束
              </el-tag
              >
            </td>
            <td>手机号</td>
            <td>{{ detail.phone }}</td>
          </tr>
          <tr>
            <td>所在地区</td>
            <td v-if="detail.address" colspan="3">
              {{
                detail.address.province +
                detail.address.city +
                detail.address.area
              }}
            </td>
          </tr>
          <tr>
            <td>技术详情</td>
            <td colspan="3">{{ detail.detile }}</td>
          </tr>
        </table>
        <div class="detail-footer">
          <el-button
              @click="handleSuccess(detail)"
              type="primary"
              v-if="[1].includes(detail.tech_status)"
          >标记为已完成转让
          </el-button
          >
          <el-button
              @click="handleFind(detail)"
              type="success"
              v-if="[1].includes(detail.tech_status)"
          >标记为找到合适供需
          </el-button
          >
          <el-button
              v-if="[1].includes(detail.tech_status)"
              @click="handleEnd(detail)"
              type="warning"
          >结束
          </el-button
          >
          <el-button @click="handleDelete(detail)" type="danger"
          >删除
          </el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import GradientButton from "@/components/button/gradient-button.vue";
import {getDictValuesByKey, getAreaOptions} from "@/api/modules/common.js";
import {
  techList,
  addTech,
  checkCasNo,
  techEnd,
  techDetail,
  techDelete,
  success,
  find,
  editTech
} from "@/api/modules/user.js";

export default {
  name: "technology",

  components: {
    GradientButton,
  },
  data() {
    return {
      titleDing: "",
      popuploading: false,
      // 技术供需详情弹窗
      detailVisible: false,
      detail: {},
      // 新增技术供需弹窗
      dialogVisible: false,
      addForm: {
        type: "",
        title: "",
        cas_no: "",
        upto_at: "",
        phone: "",
        address: [],
        detile: "",
        co_type: "",
        price: "",
        tech_maturity: "",
        tech_type: "",
      },
      addFormRules: {
        type: [
          {required: true, message: "请选择供需类型", trigger: "change"},
        ],
        cas_no: [
          {required: true, validator: this.checkCasNoRule, trigger: "blur"},
        ],
        upto_at: [
          {required: true, message: "请选择截止日期", trigger: "change"},
             {
      validator: this.validateUptoDate,
      trigger: "change"
    }
        ],
        phone: [
          {required: true, message: "请输入手机号", trigger: "blur"},
          {
            pattern: /^1[3-9]\d{9}$/,
            message: "请输入正确的手机号",
            trigger: "blur",
          },
        ],
        title: [{required: true, message: "请输入标题", trigger: "blur"}],
        tech_type: [
          {required: true, message: "请选择技术类型", trigger: "change"},
        ],
        co_type: [
          {required: true, message: "请选择合作方式", trigger: "change"},
        ],
        tech_maturity: [
          {required: true, message: "请选择技术成熟度", trigger: "change"},
        ],
        detile: [
          {required: true, message: "请输入技术详情", trigger: "blur"},
        ],
        address: [
          {required: true, message: "请选择所在地区", trigger: "change"},
        ],
      },
      // 搜索表单
      form: {
        cas_no: "",
        title: "",
        tech_type: "",
        created_at: [],
      },
      // 技术供需列表
      tableData: [],
      // 总条数
      total: 0,
      // 当前页
      page: 1,
      // 每页条数
      pageSize: 10,
      // 合作方式字典项
      coTypeList: [],
      // 技术类型字典项
      technologyList: [],
      // 省市区字典项
      areaOptions: [],
      // 技术成熟度字典项
      techMaturityList: [],
      loading: false,
      // 编辑的id
      editId: '',
    };
  },
  created() {
    this.init();
  },
  mounted() {
    this.getList();
  },
  methods: {

  validateUptoDate(rule, value, callback) {
    if (value) {
      const selectedDate = new Date(value);
      const today = new Date();
      // 将时间部分设置为0，只比较日期部分
      selectedDate.setHours(0, 0, 0, 0);
      today.setHours(0, 0, 0, 0);

      if (selectedDate <= today) {
        callback(new Error('截止日期必须大于当前日期'));
      } else {
        callback();
      }
    } else {
      callback();
    }
  },
    detailClose() {
      this.detailVisible = false;
    },
    handleSuccess(row) {
      this.$confirm("确定标记为已完成转让吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        success(row.id).then((res) => {
          if (res.data.code == 10000) {
            this.$message.success({
              message: res.data.message,
              duration: 2000,
              offset: 200,
            });
            this.detailVisible = this.detailVisible ? false : false;
            this.getList();
            this.getDetail(row.id);
          } else {
            this.$message.error({
              message: res.data.message,
              duration: 2000,
              offset: 200,
            });
          }
        });
      });
    },
    handleFind(row) {
      this.$confirm("确定标记为找到合适供需吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        find(row.id).then((res) => {
          if (res.data.code == 10000) {
            this.$message.success({
              message: res.data.message,
              duration: 2000,
              offset: 200,
            });
            this.detailVisible = this.detailVisible ? false : false;
            this.getList();
            this.getDetail(row.id);
          } else {
            this.$message.error({
              message: res.data.message,
              duration: 2000,
              offset: 200,
            });
          }
        });
      });
    },
    // 查看技术供需
    handleDetail(row) {
      this.detailVisible = true;
      this.popuploading = true;
      this.getDetail(row.id);
    },
    getDetail(id) {
      techDetail(id).then((res) => {
        if (res.data.code == 10000) {
          this.detail = res.data.data;
          this.popuploading = false;
        }
      });
    },
    init() {
      // 获取合作方式字典项
      getDictValuesByKey({key: "co_type"}).then((res) => {
        this.coTypeList = res.data.values;
      });
      // 获取技术类型字典项
      getDictValuesByKey({key: "tech_type"}).then((res) => {
        this.technologyList = res.data.values;
      });
      // 获取技术成熟度字典项
      getDictValuesByKey({key: "tech_maturity"}).then((res) => {
        this.techMaturityList = res.data.values;
      });
      this.getAreaOptions();
    },
    // 获取省市区
    getAreaOptions() {
      getAreaOptions().then((res) => {
        this.areaOptions = res.data.data.map((item) => {
          return {
            value: item.id,
            label: item.name,
            children: item.children.map((item) => {
              return {
                value: item.id,
                label: item.name,
                children: item.children.map((item) => {
                  return {
                    value: item.id,
                    label: item.name,
                  };
                }),
              };
            }),
          };
        });
      });
    },
    // 删除技术供需
    handleDelete(row) {

      this.$confirm(
          "删除后将无法恢复，请谨慎操作！确定删除该技术供需吗？",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
      ).then(() => {
        techDelete(row.id).then((res) => {
          if (res.data.code == 10000) {
            this.$message.success({
              message: res.data.message,
              duration: 2000,
              offset: 200,
            });
            this.detailVisible = this.detailVisible ? false : false;
            this.getList();
          } else {
            this.$message.error({
              message: res.data.message,
              duration: 2000,
              offset: 200,
            });
          }
        });
      });
    },
    // 结束技术供需
    handleEnd(row) {

      this.$confirm("确定结束该技术供需吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        techEnd(row.id).then((res) => {
          if (res.data.code == 10000) {
            this.$message.success({
              message: res.data.message,
              duration: 2000,
              offset: 200,
            });
            this.detailVisible = this.detailVisible ? false : false;
            this.getList();
          } else {
            this.$message.error({
              message: res.data.message,
              duration: 2000,
              offset: 200,
            });
          }
        });
      });
    },
    // 校验CAS号
    checkCasNoRule(rule, value, callback) {
      if (value) {
        checkCasNo(value).then((res) => {
          if (res.data.code == 10000) {
            // 校验通过
            callback();
          } else {
            // 校验不通过
            callback(new Error(res.data.message));
          }
        });
      } else {
        callback();
      }
    },
    getList() {
      this.loading = true;
      let data = this.form;
      data.page = this.page;
      data.limit = this.pageSize;
      techList(data).then((res) => {
        if (res.data.code == 10000) {
          this.tableData = res.data.data.data;
          this.total = res.data.data.total;
        }
        this.loading = false;
      });
    },
    handleCancel() {
      this.dialogVisible = false;
      // 刷新表单字段
    },
    handleConfirm() {
      this.$refs["addFormRules"].validate((valid) => {
        if (valid) {
          if (!this.addForm.price) {
            this.addForm.price = 0;
          }
          // 如果是编辑
          if (this.editId) {
            editTech(this.editId, this.addForm).then(res => {
              if (res.data.code == 10000) {
                this.$message.success({
                  message: res.data.message,
                  duration: 2000,
                  offset: 200,
                });
                this.dialogVisible = false;
                this.$refs["addFormRules"].resetFields();
                this.getList();
              } else {
                this.$message.error({
                  message: res.data.message,
                  duration: 2000,
                  offset: 200,
                });
              }
            })
          } else {
            // 如果是新增
            addTech(this.addForm).then((res) => {
              if (res.data.code == 10000) {
                this.$message.success({
                  message: res.data.message,
                  duration: 2000,
                  offset: 200,
                });
                this.dialogVisible = false;
                this.$refs["addFormRules"].resetFields();
                this.getList();
              } else {
                this.$message.error({
                  message: res.data.message,
                  duration: 2000,
                  offset: 200,
                });
              }
            });
          }

        } else {
          return false;
        }
      });
    },
    handleSearch() {
      this.page = 1;
      this.getList();
    },
    handleReset() {
      this.form = {
        cas_no: "",
        title: "",
        tech_type: "",
        created_at: [],
      };
      this.page = 1;
      this.getList();
    },
    handleRelease(item) {
      if(!this.mixCheckUserAudit()){
        return
      }
        this.dialogVisible = true;
        // 如果是编辑
        if (item) {
          this.titleDing = '编辑'
          this.editId = item.id
          this.setInfo()

        } else {
          this.titleDing = '新增'
          this.$nextTick(() => {
            if (this.$refs["addFormRules"]) {
              this.$refs["addFormRules"].resetFields();
            }
          });
        }

    },
    async setInfo() {
      let res = await techDetail(this.editId)
      if (res.data.code == 10000) {
        let data = res.data.data
        this.addForm = {
          type: data.type,
          title: data.title,
          cas_no: data.cas_no,
          upto_at: data.upto_at,
          phone: data.phone,
          address: [data.address.provinceId, data.address.cityId, data.address.areaId],
          detile: data.detile,
          co_type: data.co_type,
          price: data.price,
          tech_maturity: data.tech_maturity,
          tech_type: data.tech_type,
        }

      }
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
  },
};
</script>
<style scoped lang="scss">
// 弹窗下划线
::v-deep .el-dialog__header {
  border-bottom: 1px solid #e5e5e5;
}

::v-deep .el-date-editor.el-input {
  width: 100%;
}

::v-deep .el-select {
  width: 100%;
}

::v-deep .el-cascader {
  width: 100%;
}

.detail-footer {
  display: flex;
  justify-content: space-around;
  padding-top: 20px;
}

.form-box {
  padding: 0 80px 0 100px;
}

.detail-box {
  padding: 20px 40px;

  .detail-table {
    width: 100%;
    border-collapse: collapse; /* 关键：合并边框 */
    border-color: #f3f3f3;
    /* 新增样式规则 */
    td:nth-child(1),
    td:nth-child(3) {
      width: 100px;
      height: 40px;
      background: #f9faff;
      text-align: center;
      line-height: 40px;
      color: #5f616c;
    }

    td:nth-child(2),
    td:nth-child(4) {
      height: 40px;
      line-height: 40px;
      padding-left: 33px;
      border: 1px solid #f3f3f3;
      color: #00112b;
    }
  }
}

.content {
  padding: 0 0 20px;

  .fotter-box {
    // height: 635px;
    background: #ffffff;
    border-radius: 4px 4px 4px 4px;
    padding: 20px;

    .pagination-box {
      padding: 20px;

      .float-right {
        float: right;
      }
    }
  }

  .top-box {
    // height: 220px;
    background: #ffffff;
    border-radius: 6px 6px 6px 6px;
    padding: 30px 0;

    ::v-deep .el-form-item {
      margin-bottom: 0;
    }

    .search-btn {
      width: 120px;
      // height: 50px;
      background: #1890ff;
      border-radius: 4px 4px 4px 4px;
      border: 1px solid #2979f1;
      font-weight: 400;
      font-size: 18px;
      color: #ffffff;
      text-align: center;
      // line-height: 50px;
    }

    .reset-btn {
      width: 120px;
      // height: 50px;
      border-radius: 4px 4px 4px 4px;
      border: 1px solid #5f616c;
      font-weight: 400;
      font-size: 18px;
      color: #5f616c;
      // line-height: 50px;
      text-align: center;
    }
  }

  .content-box {
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
    align-items: center;
    padding: 20px 0;

    .content-box-left {
      font-weight: 800;
      font-size: 20px;
      color: #00112b;
    }
  }
}
</style>
